import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const VALUES = [
  { k: "Hardware + Brainpower", v: "We are the rare partner that owns both the physical screen and the intelligent strategy behind it." },
  { k: "Outcome-Based", v: "We measure success by acquisition and retention — not impressions or vanity metrics." },
  { k: "Automate, then Elevate", v: "HaloFlow handles the routine 24/7 so our humans focus on creative and commercial judgment." },
];

export default function About() {
  return (
    <div className="bg-white min-h-screen" data-testid="about-page">
      <Navbar />
      <main className="pt-32 pb-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
            <p className="text-xs sm:text-sm uppercase tracking-[0.2em] font-semibold text-ember">About Us</p>
            <h1 className="mt-4 font-heading font-extrabold tracking-tight text-ink text-4xl sm:text-5xl lg:text-6xl">
              Visionary Growth Partners.
            </h1>
            <p className="mt-6 text-lg text-slatey leading-relaxed">
              On The Brink is an AI-first service agency operating a hybrid brand architecture. Through On The Brink Media
              Group LLC we engineer and install physical AV infrastructure; through On The Brink Marketing Group, Inc.
              (OTBMG) we deploy autonomous Agentic AI marketing that maximizes every message on those screens — and beyond.
            </p>
            <p className="mt-5 text-lg text-slatey leading-relaxed">
              Our proprietary engine, HaloFlow, powers voice intake, scheduling, and lead routing across faith, medical,
              home services, legal, and SMB verticals — delivering measurable, outcome-based growth for enterprise and
              small business alike.
            </p>
          </motion.div>

          <div className="mt-14 grid gap-6 sm:grid-cols-3">
            {VALUES.map((val) => (
              <div key={val.k} className="border border-slate-200 p-7">
                <h3 className="font-heading font-bold text-ink">{val.k}</h3>
                <p className="mt-3 text-sm text-slatey leading-relaxed">{val.v}</p>
              </div>
            ))}
          </div>

          <Link to="/contact" data-testid="about-cta"
                className="mt-12 inline-flex items-center gap-2 bg-ink text-white px-7 py-4 text-sm font-semibold hover:bg-ink-soft transition-colors">
            Partner With Us <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
